import { useQuery } from '@zg-rentals/react-query5';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';
import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import AutoCompleteAddresses from '../../model/AutoCompleteAddresses';

const MIN_LENGTH_REQUIRED_BY_API = 7;

const useAddressAutocomplete = () => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  const [partialAddress, setPartialAddress] = useState('');

  const queryFn = () =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/properties/addresses/autocomplete`,
      requestConfig,
      config: { params: { partialAddress }, timeout: 5000 },
    });

  const queryHook = useQuery({
    queryKey: ['getAddressAutocomplete', partialAddress],
    queryFn: async () => {
      const data = await queryFn();
      return AutoCompleteAddresses(data);
    },
    staleTime: 10 * 1000,
    enabled: Boolean(partialAddress.length > MIN_LENGTH_REQUIRED_BY_API),
  });

  return [setPartialAddress, queryHook] as const;
};

export { useAddressAutocomplete };
